import React, { Component } from "react";

import MoshiContext from "../../../../context/moshiContext";

import HeaderNasumoshi from "./Nasumoshi";
import HeaderHokemoshi from "./Hokemoshi";

class Obj extends Component {
  //	const components = [nil, nil,HeaderHokemoshi, nil ,nil, HeaderNasumoshi]
  render() {
    return (
      <MoshiContext.Consumer>
        {(moshi) => {
          switch (moshi.moshi_id) {
            case 2:
              return <HeaderHokemoshi />;
            case 5:
              return <HeaderNasumoshi />;
            default:
              return <HeaderHokemoshi />;
          }
        }}
      </MoshiContext.Consumer>
    );
  }
}

export default Obj;
